export default function IconPin2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-e26ae723-d188-4f0b-be83-21490367d5f0"
      data-name="Layer 2"
      viewBox="0 0 46.495 64.969"
    >
      <defs>
        <style>
          {
            ".uuid-c98df927-f47d-4687-9570-2a7355642480{fill:#392f2d;stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-eac6ce46-d4ec-425a-ae5c-55b14ab4f126" data-name="Layer 1">
        <g id="uuid-01ea6379-455c-4210-91fd-9715802b5243" data-name="g333">
          <g id="uuid-b403bf4e-565b-4d02-83f9-eb8af43743ab" data-name="g335">
            <g id="uuid-05cd71dc-ce08-4fae-8213-3864de9fe6be" data-name="g337">
              <path
                id="uuid-cf236139-987d-44df-ad9a-2439b3760686"
                d="m23.248 64.969-1.492-1.879C20.867 61.972 0 35.558 0 23.248 0 10.428 10.429 0 23.248 0s23.247 10.429 23.247 23.248c0 12.31-20.867 38.724-21.755 39.842l-1.492 1.879Zm0-61.158C12.53 3.81 3.81 12.53 3.81 23.248c0 8.425 12.88 26.99 19.438 35.556 6.557-8.568 19.437-27.136 19.437-35.556 0-10.718-8.72-19.437-19.437-19.437Z"
                className="uuid-c98df927-f47d-4687-9570-2a7355642480"
                data-name="g343"
              />
              <path
                id="uuid-04cc52dc-7317-4661-85a4-e6bb053859ee"
                d="M23.248 33.698c-6.155 0-11.162-5.007-11.162-11.162s5.007-11.162 11.162-11.162 11.161 5.008 11.161 11.162-5.007 11.162-11.161 11.162Zm0-18.513c-4.054 0-7.352 3.298-7.352 7.351s3.298 7.352 7.352 7.352 7.35-3.298 7.35-7.352-3.297-7.351-7.35-7.351Z"
                className="uuid-c98df927-f47d-4687-9570-2a7355642480"
                data-name="g347"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
